import { Component } from "react";

export default class ListingItem extends Component {
  render() {
    let wraperStyle = {
      clear: "both",
      width: "100%",
    };

    //devide the two text below i the are two
    let devider =
      this.props.primaryText && this.props.secondaryText ? ":  " : "";
    let highlighColor = this.props.highlighColor
      ? this.props.highlighColor
      : "red";
    let highlight = this.props.highlight
      ? {
          color: "#fff",
          backgroundColor: highlighColor,
          fontWeight: "bold",
          display: "inline-block",
          padding: "2px 10px",
        }
      : {};
    let primaryTextStyle = this.props.primaryTextStyle
      ? this.props.primaryTextStyle
      : {};
    let wrapperHeaderOnlyStyle = Object.assign({}, wraperStyle, {
      margin: "8px 0",
      fontSize: "20px",
    });

    return (
      <div
        style={this.props.secondaryText ? wraperStyle : wrapperHeaderOnlyStyle}
      >
        {this.props.secondaryText}
        {devider}
        <span style={Object.assign(primaryTextStyle, highlight)}>
          <strong>{this.props.primaryText}</strong>
        </span>
      </div>
    );
  }
}
